
// ⚡ Auto-generated environment.ts
export const environment = {
  production: false,
  apiBankUrl: 'https://test-pgl.finserv.tn/bank-service/api',
  apiPglUrl: 'https://test-pgl.finserv.tn/pgl-service/api',
  apiSmtUrl: 'https://test-pgl.finserv.tn/smt-service/api',
  availableUserTypes: [{"value":"smt","label":"SMT User"}],
  frontendVersionTag: '',
};
